import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

const Image = ({imageName, objectFit}) => {

  const data = useStaticQuery(graphql`
    query {
      laptopImage: file(relativePath: { eq: "laptop_tiny.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 300) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      logoImage: file(relativePath: { eq: "logo2_tiny.png" }) {
        childImageSharp {
          fluid(maxWidth: 300) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)

  return <Img alt={imageName} style={{height: "100%"}} fluid={data[imageName].childImageSharp.fluid} objectFit={objectFit} />
}

export default Image
